var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:_vm.$style.Wrap},[_c('div',{class:_vm.$style.value},[_c('img',{class:_vm.$style.image,attrs:{"src":require("@/assets/images/landscape.png"),"alt":""}}),_c('p',{class:_vm.$style.mode},[_vm._v("请旋转屏幕至横屏模式查看")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }